import { useEffect, useState } from "react";
import { Col, Form, FormFeedback, Input, Label, Row } from "reactstrap";
import { useCommonDataFindAllQuery, useMeasurementPoolCreateMutation, useMeasurementPoolFindAllQuery, useMeasurementPoolUpdateMutation } from "store";
import * as Yup from "yup";
import { useFormik } from "formik";
import Spinners from "Components/Common/Spinner";
import { Link, useParams } from "react-router-dom";
import Switch from "react-switch";
import measurementSvg from "../../../assets/images/svg/measurement.svg"
import Flatpickr from "react-flatpickr";

const Measurement = () => {
  const { id } = useParams();
  const [isLoading, setLoading] = useState(true)
  const { data, error, isFetching } = useMeasurementPoolFindAllQuery(`?pool_id=${id}`);
  const [measurementPoolCreate, measurementPoolCreateResult] = useMeasurementPoolCreateMutation();
  const [measurementPoolUpdate, measurementPoolUpdateResult] = useMeasurementPoolUpdateMutation();
  const [measurementPool, setMeasurementPool] = useState<any>();

  const [measurementList, setMeasurementList] = useState<any>();

  const [meaCount, setMeaCount] = useState<any>();

  const [contains_water, setContains_waterBoolean] = useState<boolean>(false);
  const [is_clean, setIs_cleanBoolean] = useState<boolean>(false);

  const [is_newCreated, setIs_newCreated] = useState<boolean>(false);

  useEffect(() => {
    console.log(measurementPool);
    if (measurementPool === undefined) {
      setLoading(true);
    } else {
      setLoading(false);
    }
    setMeasurementList(data?.data);
    setMeaCount(data?.data?.length)
    const tempContains_water = measurementPool !== null ? measurementPool?.contains_water : false;
    const tempIs_clean = measurementPool !== null ? measurementPool?.is_clean : false;
    setContains_waterBoolean(tempContains_water)
    setIs_cleanBoolean(tempIs_clean)
  }, [id, data, measurementPool])


  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      id: measurementPool?.id,
      pool_id: measurementPool?.pool_id,
      pool_code: measurementPool?.pool_code,
      measure_date: measurementPool?.measure_date,
      shape: measurementPool?.shape,
      average_depth: measurementPool?.average_depth,
      maximum_depth: measurementPool?.maximum_depth,

      length: measurementPool?.length,
      width: measurementPool?.width,
      water_surface: measurementPool?.water_surface,

      dam_length: measurementPool?.dam_length,

      pool_volume: measurementPool?.pool_volume,
      dam_width: measurementPool?.dam_width,
      dam_heigth: measurementPool?.dam_heigth,
      pool_design: measurementPool?.pool_design,

      pool_source_name: measurementPool?.pool_source_name,
      usage_information: measurementPool?.usage_information,

      contains_water: measurementPool?.contains_water,
      is_clean: measurementPool?.is_clean,

      sanitary_requirements: measurementPool?.sanitary_requirements,
      water_physical_quality: measurementPool?.water_physical_quality,

      report_autor: measurementPool?.report_autor,
      report_name: measurementPool?.report_name,
      report_code: measurementPool?.report_code,
    },
    validationSchema: Yup.object({
      pool_code: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      measure_date: Yup.date().typeError("Он сар өдөр оруулна уу").required("Утга оруулна уу !"),
      shape: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      average_depth: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      maximum_depth: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),

      length: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      width: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      water_surface: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),

      dam_length: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),

      pool_volume: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      dam_width: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      dam_heigth: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      pool_design: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),

      pool_source_name: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      usage_information: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),

      sanitary_requirements: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      water_physical_quality: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),

      report_autor: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      report_name: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      report_code: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {

      if (is_newCreated === false) {
        console.log(values);

        const updateList = {
          id: measurementPool ? measurementPool.id : 0,
          pool_id: measurementPool?.pool_id,
          pool_code: values?.pool_code,
          measure_date: values?.measure_date,
          shape: values?.shape,
          average_depth: values?.average_depth,
          maximum_depth: values?.maximum_depth,

          length: values?.length,
          width: values?.width,
          water_surface: values?.water_surface,

          dam_length: values?.dam_length,

          pool_volume: values?.pool_volume,
          dam_width: values?.dam_width,
          dam_heigth: values?.dam_heigth,
          pool_design: values?.pool_design,

          pool_source_name: values?.pool_source_name,
          usage_information: values?.usage_information,

          contains_water: contains_water === undefined ? false : contains_water,
          is_clean: is_clean === undefined ? false : is_clean,

          sanitary_requirements: values?.sanitary_requirements,
          water_physical_quality: values?.water_physical_quality,

          report_autor: values?.report_autor,
          report_name: values?.report_name,
          report_code: values?.report_code,

        }

        measurementPoolUpdate(updateList);
      } else {
        const newList = {
          pool_id: id,
          pool_code: values["pool_code"],
          measure_date: values["measure_date"],
          shape: values["shape"],
          average_depth: values["average_depth"],
          maximum_depth: values["maximum_depth"],

          length: values["length"],
          width: values["width"],
          water_surface: values["water_surface"],

          dam_length: values["dam_length"],

          pool_volume: values["pool_volume"],
          dam_width: values["dam_width"],
          dam_heigth: values["dam_heigth"],
          pool_design: values["pool_design"],

          pool_source_name: values["pool_source_name"],
          usage_information: values["usage_information"],

          contains_water: contains_water === undefined ? false : contains_water,
          is_clean: is_clean === undefined ? false : is_clean,

          sanitary_requirements: values["sanitary_requirements"],
          water_physical_quality: values["water_physical_quality"],

          report_autor: values["report_autor"],
          report_name: values["report_name"],
          report_code: values["report_code"],
        };

        measurementPoolCreate(newList)
      }
      // validation.resetForm();
    },
  });

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Үгүй
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Тийм
      </div>
    );
  };

  return (

    <>

      <Row>
        <Col lg={12}>
          <div className="d-flex align-items-center mb-3">
            <img src={measurementSvg} alt="" height="50" />
            <div className="flex-grow-1 ms-3">
              <h5 className="fw-semibold">Мэдээлэл</h5>
              <ul className="list-unstyled hstack gap-2 mb-0">
                <li>
                  <i className="mdi mdi-table-row-height"></i>{" "}
                  <span className="text-muted fw-semibold">
                    Нийт: {meaCount}
                  </span>
                </li>
              </ul>
            </div>

            <button
              type="button"
              disabled={is_newCreated === true ? true : false}
              className="btn btn-success  btn-label"
              onClick={() => {
                validation.resetForm();
                setMeasurementPool(null);
                setContains_waterBoolean(false);
                setIs_cleanBoolean(false);
                setIs_newCreated(true);
              }}
            >
              <i className="mdi mdi-file-plus-outline label-icon"></i>
              Шинээр нэмэх
            </button>

          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={3}>
          <ul className="verti-timeline list-unstyled">
            {measurementList?.map((item, index) => (
              <li className="event-list active">
                <div className="event-timeline-dot">
                  <i className="bx bxs-right-arrow-circle font-size-18 bx-fade-right" />
                </div>
                <div className="flex-shrink-0 d-flex">
                  <div key={index} className="d-flex mb-3">
                    <div className="me-3">
                      <h5 className="font-size-14">
                        {item?.created_at.split("T")[0]}
                        <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                      </h5>
                    </div>
                    <div className="flex-grow-1">
                      <div>
                        <Link
                          to="#"
                          className="cursor fw-semibold"
                          onClick={() => {
                            setIs_newCreated(false)
                            setMeasurementPool(item)
                          }}
                        >
                          {item?.measure_date}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </Col>
        <Col lg={9}>
          {
            isLoading ? <Spinners setLoading={setLoading} sCustomTop={'120px'} />
              :
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <Row>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Код </Label>
                      <Input
                        name="pool_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.pool_code || ""}
                        invalid={
                          validation.touched.pool_code &&
                            validation.errors.pool_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.pool_code &&
                        validation.errors.pool_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.pool_code}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Усан сан, хөв, цөөрмийн дундаж гүн, м </Label>
                      <Input
                        name="average_depth"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.average_depth || ""}
                        invalid={
                          validation.touched.average_depth &&
                            validation.errors.average_depth
                            ? true
                            : false
                        }
                      />
                      {validation.touched.average_depth &&
                        validation.errors.average_depth ? (
                        <FormFeedback type="invalid">
                          {validation.errors.average_depth}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Усан сан, хөв, цөөрмийн дундаж гүн, м </Label>
                      <Input
                        name="width"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.width || ""}
                        invalid={
                          validation.touched.width &&
                            validation.errors.width
                            ? true
                            : false
                        }
                      />
                      {validation.touched.width &&
                        validation.errors.width ? (
                        <FormFeedback type="invalid">
                          {validation.errors.width}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Усан сан, хөв, цөөрмийн эзэлхүүн, м3 </Label>
                      <Input
                        name="pool_volume"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.pool_volume || ""}
                        invalid={
                          validation.touched.pool_volume &&
                            validation.errors.pool_volume
                            ? true
                            : false
                        }
                      />
                      {validation.touched.pool_volume &&
                        validation.errors.pool_volume ? (
                        <FormFeedback type="invalid">
                          {validation.errors.pool_volume}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Горим, хийц зохиомж  </Label>
                      <Input
                        name="pool_design"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.pool_design || ""}
                        invalid={
                          validation.touched.pool_design &&
                            validation.errors.pool_design
                            ? true
                            : false
                        }
                      />
                      {validation.touched.pool_design &&
                        validation.errors.pool_design ? (
                        <FormFeedback type="invalid">
                          {validation.errors.pool_design}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Устай эсэх </Label> <br />
                      <Switch
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        className="me-1 mb-sm-8 mb-2 ms-3"
                        onColor="#626ed4"
                        onChange={() => {
                          setContains_waterBoolean(!contains_water);
                        }}
                        checked={contains_water}
                      />
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Усны физик шинж чанар </Label>
                      <Input
                        name="water_physical_quality"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.water_physical_quality || ""}
                        invalid={
                          validation.touched.water_physical_quality &&
                            validation.errors.water_physical_quality
                            ? true
                            : false
                        }
                      />
                      {validation.touched.water_physical_quality &&
                        validation.errors.water_physical_quality ? (
                        <FormFeedback type="invalid">
                          {validation.errors.water_physical_quality}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Тайлангийн фондын бүртгэлийн дугаар </Label>
                      <Input
                        name="report_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_code || ""}
                        invalid={
                          validation.touched.report_code &&
                            validation.errors.report_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_code &&
                        validation.errors.report_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_code}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>

                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Хэмжилт хийсэн огноо </Label>
                      <Flatpickr
                        className="form-control d-block"
                        placeholder="Огноо"
                        name="measure_date"
                        value={validation.values.measure_date}
                        onChange={(selectDate: Date[]) => {
                          if (selectDate[0]) {
                            const localDate = new Date(selectDate[0].getTime() - selectDate[0].getTimezoneOffset() * 60000)
                              .toISOString()
                              .split('T')[0];
                            validation.setFieldValue('measure_date', localDate);
                          }
                        }}
                        options={{
                          altInput: true,
                          altFormat: "Y-m-d",
                          dateFormat: "Y-m-d",
                          enableTime: false,
                        }}
                      />
                      {validation.touched.measure_date &&
                        validation.errors.measure_date ? (
                        <FormFeedback type="invalid">
                          {validation.errors.measure_date}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Хамгийн их гүн, м </Label>
                      <Input
                        name="maximum_depth"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.maximum_depth || ""}
                        invalid={
                          validation.touched.maximum_depth &&
                            validation.errors.maximum_depth
                            ? true
                            : false
                        }
                      />
                      {validation.touched.maximum_depth &&
                        validation.errors.maximum_depth ? (
                        <FormFeedback type="invalid">
                          {validation.errors.maximum_depth}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Усан сан, хөв, цөөрмийн усан мандлын талбай </Label>
                      <Input
                        name="water_surface"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.water_surface || ""}
                        invalid={
                          validation.touched.water_surface &&
                            validation.errors.water_surface
                            ? true
                            : false
                        }
                      />
                      {validation.touched.water_surface &&
                        validation.errors.water_surface ? (
                        <FormFeedback type="invalid">
                          {validation.errors.water_surface}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> өргөн, м  </Label>
                      <Input
                        name="dam_width"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.dam_width || ""}
                        invalid={
                          validation.touched.dam_width &&
                            validation.errors.dam_width
                            ? true
                            : false
                        }
                      />
                      {validation.touched.dam_width &&
                        validation.errors.dam_width ? (
                        <FormFeedback type="invalid">
                          {validation.errors.dam_width}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Эх үүсвэрийн нэр  </Label>
                      <Input
                        name="pool_source_name"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.pool_source_name || ""}
                        invalid={
                          validation.touched.pool_source_name &&
                            validation.errors.pool_source_name
                            ? true
                            : false
                        }
                      />
                      {validation.touched.pool_source_name &&
                        validation.errors.pool_source_name ? (
                        <FormFeedback type="invalid">
                          {validation.errors.pool_source_name}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Эрүүл ахуйн шаардлага хангасан эсэх </Label> <br />
                      <Switch
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        className="me-1 mb-sm-8 mb-2 ms-3"
                        onColor="#626ed4"
                        onChange={() => {
                          setIs_cleanBoolean(!is_clean);
                        }}
                        checked={is_clean}
                      />
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Эх үүсвэрийн нэр  </Label>
                      <Input
                        name="report_autor"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_autor || ""}
                        invalid={
                          validation.touched.report_autor &&
                            validation.errors.report_autor
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_autor &&
                        validation.errors.report_autor ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_autor}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>

                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Талбайн хэлбэр  </Label>
                      <Input
                        name="shape"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.shape || ""}
                        invalid={
                          validation.touched.shape &&
                            validation.errors.shape
                            ? true
                            : false
                        }
                      />
                      {validation.touched.shape &&
                        validation.errors.shape ? (
                        <FormFeedback type="invalid">
                          {validation.errors.shape}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Усан сан, хөв, цөөрмийн урт, м  </Label>
                      <Input
                        name="length"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.length || ""}
                        invalid={
                          validation.touched.length &&
                            validation.errors.length
                            ? true
                            : false
                        }
                      />
                      {validation.touched.length &&
                        validation.errors.length ? (
                        <FormFeedback type="invalid">
                          {validation.errors.length}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold">Далангийн урт, м  </Label>
                      <Input
                        name="dam_length"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.dam_length || ""}
                        invalid={
                          validation.touched.dam_length &&
                            validation.errors.dam_length
                            ? true
                            : false
                        }
                      />
                      {validation.touched.dam_length &&
                        validation.errors.dam_length ? (
                        <FormFeedback type="invalid">
                          {validation.errors.dam_length}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold">өндөр, м </Label>
                      <Input
                        name="dam_heigth"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.dam_heigth || ""}
                        invalid={
                          validation.touched.dam_heigth &&
                            validation.errors.dam_heigth
                            ? true
                            : false
                        }
                      />
                      {validation.touched.dam_heigth &&
                        validation.errors.dam_heigth ? (
                        <FormFeedback type="invalid">
                          {validation.errors.dam_heigth}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold">Ашиглалтын талаарх мэдээлэл</Label>
                      <Input
                        name="usage_information"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.usage_information || ""}
                        invalid={
                          validation.touched.usage_information &&
                            validation.errors.usage_information
                            ? true
                            : false
                        }
                      />
                      {validation.touched.usage_information &&
                        validation.errors.usage_information ? (
                        <FormFeedback type="invalid">
                          {validation.errors.usage_information}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold">Ариун цэвэр,эрүүл ахуйн шаардлага хангалт</Label>
                      <Input
                        name="sanitary_requirements"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.sanitary_requirements || ""}
                        invalid={
                          validation.touched.sanitary_requirements &&
                            validation.errors.sanitary_requirements
                            ? true
                            : false
                        }
                      />
                      {validation.touched.sanitary_requirements &&
                        validation.errors.sanitary_requirements ? (
                        <FormFeedback type="invalid">
                          {validation.errors.sanitary_requirements}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold">Тайлангийн нэр</Label>
                      <Input
                        name="report_name"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_name || ""}
                        invalid={
                          validation.touched.report_name &&
                            validation.errors.report_name
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_name &&
                        validation.errors.report_name ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_name}
                        </FormFeedback>
                      ) : null}
                    </div>

                  </Col>


                  <Col lg={12} className="d-flex justify-content-center mt-3">
                    <button type="submit" className="btn btn-primary"> Хадгалах </button>
                  </Col>
                </Row>
              </Form>
          }
        </Col>
      </Row>
    </>
  )
}

export default Measurement;